import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { DraftBanner, DraftBannerAction } from '../../../drafts/components/DraftBanner';
import { appStore } from '../../AppStore';
import { editWorkbook } from '../../actions/spaces/EditWorkbookAction';
import { ISpaceItemDetailInfo } from '../../../ts/models/ISpaceItemDetailInfo';
import { discardDraftRequestedAction } from '../../../drafts/actions/DiscardDraftAction';
import { DraftWorkbookSpaceProps } from '../../../drafts/types/DraftsTypes';

export type WorkbookSpaceHeaderDraftBannerProps = {
  readonly draftInfo: DraftWorkbookSpaceProps;
  readonly workbookContent: ISpaceItemDetailInfo<'workbook'>;
};

export function WorkbookSpaceHeaderDraftBanner(props: WorkbookSpaceHeaderDraftBannerProps): JSX.Element {
  const handleEditDraft = () => {
    if (props.workbookContent) {
      appStore.dispatch(editWorkbook(props.workbookContent));
    }
  };

  const handleDiscardDraft = () => {
    let content = props.workbookContent;
    appStore.dispatch(discardDraftRequestedAction(props.draftInfo.draftLuid, content.contentType, content.luid, content.name));

  };

  const draftBannerActions: DraftBannerAction[] = [];
  draftBannerActions.push({
    label: Messages.continueEditing(),
    handleAction: handleEditDraft,
    iconPath: imgPath('pencil_14px_small.svg'),
    testId: 'continue-editing'
    },
    {label: Messages.discardChanges(),
    handleAction: handleDiscardDraft,
    iconPath: imgPath('trash_14px_small.svg'),
    testId: 'discard-changes'
    });

  return (
    <DraftBanner
      lastEditDate={props.draftInfo.draftUpdatedAt}
      draftBannerActions={draftBannerActions}
      contentTypeName={Messages.lastEditedDraft()}
    />
  );
}
